<app-header [config]="headerConfig?.config"></app-header>
<app-product-header [config]="productHeaderConfig?.config" [data]="smartLabelData"></app-product-header>
<app-badge-segment [config]="badgeConfig?.config"></app-badge-segment>
<app-tabs [config]="tabConfig.config" [controls]="tabConfig.controls"></app-tabs>
<app-rich-text [config]="footer1Config?.config"></app-rich-text>
<app-rich-text [config]="footer2Config?.config"></app-rich-text>
<app-footer [config]="informationAccuracyConfig?.config"></app-footer>
<app-footer-links [config]="footerLinksConfig?.config"></app-footer-links>
<app-social [config]="socialLinksConfig?.config"></app-social>